import * as _ from 'lodash';

export class Entity {

  constructor(jsonObj: any) {
    if (jsonObj) {
      // $.extend(this, jsonObj);
      _.merge(this, jsonObj);
    }
  }

  public clone(): any {
    // const cloneObj = new (<any>this.constructor)(null); // line fixed
    // for (const attribut in this) {
    //   if (this.hasOwnProperty(attribut)) {
    //     cloneObj[attribut] = this._clone(this[attribut]);
    //   }
    // }
    // return cloneObj;
    return _.cloneDeep(this);
  }

  // private _clone(srcObj: any): any {
  //   if (srcObj instanceof Object && !(srcObj instanceof Array)) {
  //     if (srcObj instanceof Entity) {
  //       return (<Entity>srcObj).clone();
  //     } else if (srcObj instanceof Date) {
  //       return new Date(srcObj);
  //     } else {
  //       return Object.assign({}, srcObj);
  //     }
  //   } else if (srcObj instanceof Array) {
  //     return this._cloneArray(srcObj);
  //   } else {
  //     return srcObj;
  //   }
  // }
  //
  // private _cloneArray(srcObj: any[]): any[] {
  //   const cloneArray: any[] = [];
  //   srcObj.map(element => {
  //     cloneArray.push(this._clone(element));
  //   });
  //
  //   return cloneArray;
  // }
}
